import { useCreateCaseManager } from './CreateCaseManager';

export const useCreateCaseState = () => {
    const state = useCreateCaseManager();

    return state;
};
